module.exports = __webpack_public_path__ + "img/党建1.7a2b5511.jpg";